import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BikeLogo from "../assets/logo.jpeg";
import { Link } from "react-router-dom";
import Banner from "./Banner";
import SearchBar from "./SearchBar";

var url = '/Users/kylep/Bike-Shop-react/src/data.js'

const Nav = ({ numberOfItems }) => {

  const [isLoading, setIsLoading] = useState(false);
  const [query, setQuery] = useState("");
  const [bicycle, setBicycle] = useState([]);

  // opens menu
  function openMenu() {
    document.body.classList += " menu--open"
  }

  // closes menu
  function closeMenu() {
    document.body.classList.remove("menu--open");
  }

  const searchBike = async () => {
    setIsLoading(true);
    const urls = url + query
    const res = await fetch(urls);
    const data = await res.json();
    console.log(res);
    setBicycle(data.meals);
    setIsLoading(false);
  };

  useEffect(() => {
    searchBike();
  })

  // resets the search bar
  const handleSubmit = (event) => {
    event.preventDefault();
    searchBike()
  }

  function handleSignIn(){
    alert("Feature Coming soon")
  }

  return (
    <>
      <Banner />
      <nav>
        <div className="nav__container">
          <Link to="/">
            <img src={BikeLogo} alt="The Bike Shop" className="logo" />
          </Link>

          {/* Search bar */}
          {/* <SearchBar
            handleSubmit={handleSubmit}
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            isLoading={isLoading}
          /> */}

          <ul className="nav__links">
            <li className="nav__list">
              <Link to="/" className="nav__link">
                Home
              </Link>
            </li>
            <li className="nav__list">
              <Link to="/bikes" className="nav__link">
                Bike
              </Link>
            </li>
            {/* <li className="nav__list">
              <Link to="/contact" className="nav__link">
                Contact
              </Link>
            </li> */}
            <li className="nav__list">
              <Link onClick={() => alert("Feature coming soon!")} to="/" className="nav__link">
                Login
              </Link>
            </li>
            <button className="btn__menu" onClick={openMenu}>
              <FontAwesomeIcon icon="fa-solid fa-bars" />
            </button>
            <li className="nav__icon">
              <Link to="/cart" className="nav__link">
                <FontAwesomeIcon icon="shopping-cart" />
              </Link>
              {numberOfItems > 0 && (
                <span className="cart__length">{numberOfItems}</span>
              )}
            </li>
          </ul>

          <div className="menu__backdrop">
            <button className="btn__menu btn__menu--close" onClick={closeMenu}>
              <FontAwesomeIcon icon="times" />
            </button>

            <ul className="menu__links">
              {/* Search bar */}
              <SearchBar />
              <li className="menu__list">
                <Link to="/" className="menu__link">
                  Home
                </Link>
              </li>

              <li className="menu__list">
                <Link to="/bikes" className="menu__link">
                  Bike
                </Link>
              </li>

              <li className="menu__list">
                <Link onClick={() => alert("Feature coming soon!")} to="/" className="menu__link">
                  Login
                </Link>
              </li>

              {/* <li className="nav__list">
                <Link to="/contact" className="nav__link">
                  Contact
                </Link>
              </li> */}

              <li className="menu__list">
                <Link to="/cart" className="menu__link">
                  Cart
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Nav;